export type NavigationLocale = "en-US" | "ja-JP" | "ko-KR";

const STRINGS: Record<
  NavigationLocale,
  {
    home: string;
    graphExplorer: string;
    communitea: string;
    feedback: string;
    adminSection: string;
    adminHome: string;
    reportedItems: string;
    userFeedback: string;
    resourcesSection: string;
    aboutSocietea: string;
    getHelp: string;
    buildSocietea: string;
    privacySafetySection: string;
    contentPolicy: string;
    privacyPolicy: string;
    userAgreement: string;
    recentSection: string;
    prioriteaSection: string;
    closeSideNavigation: string;
    sideNavigation: string;
    footer: string;
  }
> = {
  "en-US": {
    home: "Home",
    graphExplorer: "Graph Explorer",
    communitea: "Communitea",
    feedback: "Feedback",
    adminSection: "Admin",
    adminHome: "Admin Home",
    reportedItems: "Reported Items",
    userFeedback: "User Feedback",
    resourcesSection: "Resources",
    aboutSocietea: "About Societea",
    getHelp: "Get Help",
    buildSocietea: "Build Societea",
    privacySafetySection: "Privacy & Safety",
    contentPolicy: "Content Policy",
    privacyPolicy: "Privacy Policy",
    userAgreement: "User Agreement",
    recentSection: "Recent",
    prioriteaSection: "Prioritea",
    closeSideNavigation: "Close side navigation menu",
    sideNavigation: "Side navigation",
    footer: "Societea, Inc. © {year}. All rights reserved.",
  },
  "ja-JP": {
    home: "ホーム",
    graphExplorer: "グラフエクスプローラー",
    communitea: "Communitea",
    feedback: "フィードバック",
    adminSection: "管理",
    adminHome: "管理ホーム",
    reportedItems: "報告された項目",
    userFeedback: "ユーザーフィードバック",
    resourcesSection: "リソース",
    aboutSocietea: "Societeaについて",
    getHelp: "ヘルプを受ける",
    buildSocietea: "Societeaをつくる",
    privacySafetySection: "プライバシーと安全",
    contentPolicy: "コンテンツポリシー",
    privacyPolicy: "プライバシーポリシー",
    userAgreement: "利用規約",
    recentSection: "最近",
    prioriteaSection: "Prioritea",
    closeSideNavigation: "サイドナビゲーションメニューを閉じる",
    sideNavigation: "サイドナビゲーション",
    footer: "Societea, Inc. © {year}. 無断複写・転載を禁じます。",
  },
  "ko-KR": {
    home: "홈",
    graphExplorer: "그래프 탐색기",
    communitea: "Communitea",
    feedback: "피드백",
    adminSection: "관리자",
    adminHome: "관리자 홈",
    reportedItems: "신고된 항목",
    userFeedback: "사용자 피드백",
    resourcesSection: "리소스",
    aboutSocietea: "Societea 소개",
    getHelp: "도움 받기",
    buildSocietea: "Societea 만들기",
    privacySafetySection: "개인정보 및 안전",
    contentPolicy: "콘텐츠 정책",
    privacyPolicy: "개인정보 처리방침",
    userAgreement: "이용 약관",
    recentSection: "최근",
    prioriteaSection: "Prioritea",
    closeSideNavigation: "사이드 내비게이션 메뉴 닫기",
    sideNavigation: "사이드 내비게이션",
    footer: "Societea, Inc. © {year}. 판권 소유.",
  },
};

export function resolveNavigationLocale(): NavigationLocale {
  if (typeof navigator === "undefined" || !navigator.language) {
    return "en-US";
  }
  const lang = navigator.language.toLowerCase();
  if (lang.startsWith("ja")) {
    return "ja-JP";
  }
  if (lang.startsWith("ko")) {
    return "ko-KR";
  }
  return "en-US";
}

export function getNavigationUiStrings(locale?: NavigationLocale): (typeof STRINGS)["en-US"] {
  const key = locale ?? resolveNavigationLocale();
  return STRINGS[key] ?? STRINGS["en-US"];
}
